import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'
import CaseForm from '@/modules/Case/components/CaseForm.vue'
import { Case } from '@/modules/Case/interfaces/case'
import { ReducedUser } from '@/modules/User/interfaces/user'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import { deleteCaseById, assignCase, openCase, closeCase, updateCaseStatus } from '@/modules/Case/gql/case.gql'

@Component({
  components: {
    AppDialog,
    CaseForm
  }
})

export default class CaseDialog extends Vue {
  targetCase: Case | null = null

  caseDialog = {
    show: false,
    title: 'New Case',
    disable: false,
    actionType: 'new'
  }

  assignDialog: {
    [key: string]: any
  } = {
    show: false,
    title: 'Assigned to',
    disable: false
  }

  deleteCaseDialog = {
    show: false,
    title: 'Delete Case',
    text: ''
  }

  closeCaseDialog = {
    show: false,
    isClose: true,
    title: 'Close Case',
    text: ''
  }

  caseStatusDialog = {
    show: false,
    status: 'INQUIRY'
  }

  staff: ReducedUser[] = []

  get staffNames () {
    return this.staff.map(staff => staff.username)
  }

  showCaseDialog (e: Event, targetCase?: Case) {
    e.preventDefault()
    e.stopPropagation()
    let actionType = 'new'
    let title = 'New Case'
    if (targetCase) {
      this.targetCase = targetCase
      actionType = 'edit'
      title = 'Edit Case'
    }
    this.caseDialog = {
      actionType,
      show: true,
      title,
      disable: false
    }
  }

  hideCaseDialog () {
    this.targetCase = null
    this.caseDialog = {
      actionType: 'new',
      show: false,
      title: 'New Case',
      disable: false
    }
  }

  async showAssignDialog (e: Event, theCase: Case) {
    e.preventDefault()
    e.stopPropagation()
    this.targetCase = theCase

    this.assignDialog.show = true
  }

  async hideAssignDialog () {
    this.assignDialog = {
      show: false,
      title: 'Assigned to',
      disable: false
    }
  }

  async deleteCase (e: Event, theCase: Case) {
    e.preventDefault()
    e.stopPropagation()
    this.targetCase = theCase
    this.deleteCaseDialog.show = true
  }

  async deleteCasePost () {
    if (!this.targetCase) {
      return
    }
    const { id } = this.targetCase
    this.deleteCaseDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteCaseById,
        variables: {
          caseId: Number(id)
        }
      })

      const res = result.data.deleteCaseById
      if (res) {
        showNotification({
          msg: 'Delete case successfully',
          type: SnackType.Success
        })
        this.targetCase = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  async assignCasePost (userIds: number[]) {
    if (!this.targetCase) {
      return
    }
    const { id } = this.targetCase
    this.hideAssignDialog()
    try {
      const result = await this.$apollo.mutate({
        mutation: assignCase,
        variables: {
          caseId: Number(id),
          userIds
        }
      })

      const res = result.data.assignCase
      if (res) {
        showNotification({
          msg: 'Assign case to staff successfully',
          type: SnackType.Success
        })
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  async closeOpenCase (e: Event, theCase: Case, isClose: boolean) {
    e.preventDefault()
    e.stopPropagation()
    this.targetCase = theCase
    this.closeCaseDialog.isClose = isClose
    this.closeCaseDialog.title = `${isClose ? 'Close' : 'Reopen'} Case`
    this.closeCaseDialog.show = true
  }

  async closeCasePost () {
    if (!this.targetCase) {
      return
    }
    const { id } = this.targetCase
    this.closeCaseDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: closeCase,
        variables: {
          caseId: Number(id)
        }
      })

      const res = result.data.closeCase
      if (res) {
        showNotification({
          msg: 'Close case successfully',
          type: SnackType.Success
        })
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  async openCasePost () {
    if (!this.targetCase) {
      return
    }
    const { id } = this.targetCase
    this.closeCaseDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: openCase,
        variables: {
          caseId: Number(id)
        }
      })

      const res = result.data.openCase
      if (res) {
        showNotification({
          msg: 'Reopen case successfully',
          type: SnackType.Success
        })
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  async switchCaseStatus (e: Event, theCase: Case, status: string) {
    e.preventDefault()
    e.stopPropagation()
    if (theCase.status === status) {
      return
    }
    this.targetCase = theCase
    this.caseStatusDialog.status = status
    this.caseStatusDialog.show = true
  }

  async switchCaseStatusPost () {
    if (!this.targetCase) {
      return
    }
    const { id } = this.targetCase
    this.caseStatusDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: updateCaseStatus,
        variables: {
          caseId: Number(id),
          status: this.caseStatusDialog.status
        }
      })

      const res = result.data.updateCaseStatus
      if (res) {
        showNotification({
          msg: 'Switch case status successfully',
          type: SnackType.Success
        })
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }
}
